export const FIRST_PAGE = 1;

export const PAGE_SIZE_OPTIONS = [
	{ value: 5, label: '5' },
	{ value: 10, label: '10' },
	{ value: 20, label: '20' },
	{ value: 30, label: '30' },
	{ value: 50, label: '50' },
	{ value: 100, label: '100' },
	{ value: 200, label: '200' }
];
